import {
  EfteruddannelseIndberetningstypeId,
  PersonEfteruddannelse,
} from "../../../../../interfaces/schema";

import { getCarriedInLessons } from "../Efteruddannelse/transferredLessons";

export const getLektionerOverfoert = (peup: PersonEfteruddannelse) =>
  getCarriedInLessons(peup);

export const getIndberetningFrist = (
  efteruddannelse: PersonEfteruddannelse,
) => {
  const indberetning = efteruddannelse.personEfteruddannelseIndberetning.find(
    (i) =>
      i.efteruddannelseIndberetningstype ===
      EfteruddannelseIndberetningstypeId.Periodeudloeb,
  );
  return indberetning?.indberetningFrist;
};
